import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Material, MaterialType } from '../models';

export const materialTypesActions = createActionGroup({
    source: 'Material Types',
    events: {
        'Get Material Types': emptyProps(),
        'Get Material Types Success': props<{ payload: MaterialType[] }>(),
        'Get Material Types Error': props<{ code: number }>(),

        'Get Materials': props<{ id: string }>(),
        'Get Materials Success': props<{ payload: Material[] }>(),
        'Get Materials Error': props<{ code: number }>(),

        Clear: emptyProps(),
    },
});
